import React from 'react';
import { GeetaDaraClass72025 } from '../views';

const AccountGeneralPage = () => {
  return <GeetaDaraClass72025 />;
};

export default AccountGeneralPage;